import React from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import GlobalSearchfilter from "../../components/common/Common/globalSearchfilter";
import "./objectFilter.css";

const Objectfilter = ({
  setClearAll,
  clearAll,
  fromTransit,
  resetHandler,
  setPage,
  photography,
  conservation,
  assign,
  condition,
  photostatus,
  driveurl,
  reference,
  iconic,
  setSelectedContents,
  selectedContents,
  setIsOpen,
  isOpen,
  toggleDrawer,
  formik,
  update,
  setUpdate,
  isClearAll,
  setIsClearAll,
}) => {
  return (
    <>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="right"
        size={370} // OR use style={{ width: 345 }}, not both
        style={{
          overflowY: "hidden",
          overflowX: "auto",
        }}
        className="bla bla bla"
      >
        <div>
          <GlobalSearchfilter
            isClearAll={isClearAll}
            setIsClearAll={setIsClearAll}
            setClearAll={setClearAll}
            clearAll={clearAll}
            resetHandler={resetHandler}
            fromTransit={fromTransit}
            isOpen={isOpen}
            photography={photography}
            conservation={conservation}
            assign={assign}
            driveUrl={driveurl}
            photostatus={photostatus}
            condition={condition}
            reference={reference}
            iconic={iconic}
            update={update}
            setUpdate={setUpdate}
            object={true}
            selectedContents={selectedContents}
            setSelectedContents={setSelectedContents}
            setIsOpen={setIsOpen}
            formik={formik}
          />
        </div>
      </Drawer>
    </>
  );
};

export default Objectfilter;
